import React, { useEffect, useState } from "react";
import useHttp from "../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData from "../NoData";
import ChartLoader from '../ChartLoader';
import CommanBarTable_Kratos from "./CommanBarTable_Kratos";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_kratos';
import WaterMark from "../DashboardMain_Kratos/WaterMark";
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales,
  Ticks
} from "chart.js";
import NoTableData from "./NoTableData";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result = []

function HvacTotalDrive_Kratos({ gloablfilter, itemSelected, modalName }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState("HVAC");
  const [barcolor, SetBarcolor] = useState("#83A4CF");
  const [yAxisTitle, SetyAxisTitle] = useState("");
  const [box_one, setBox_one] = useState(0)
  const [box_two, setBox_two] = useState(0)
  const [tableData, SetTableData] = useState([]);
  const [HVACtext, setHVACtext] = useState("total")

  const responceData = async (data) => {
    setBox_one(0)
    setBox_two(0)
    SetTableData([])
    
    res_result = []
    res_result = data;
    let responce;
    if (itemSelected === "acLoadIdle") {
      responce = {
        "<20": 0,
        "40": 0,
        "60": 0,
        "80": 0,
        "100": 0,
        "120": 0,
        "140": 0,
        "160": 0,
        "180": 0,
        ">=180": 0,
      };
    } else {
      responce = {
        "<50": 0,
        "100": 0,
        "150": 0,
        "200": 0,
        "250": 0,
        "300": 0,
        "350": 0,
        "400": 0,
        "450": 0,
        ">=450": 0,
      };
    }

    let dataCons_kWh = 0, distanceInKM = 0, dynamic_itemSelected = 0
    let vehicle_registration_number = "", Depot_Name = "", DLR_ORG_CITY = ""

    if (res_result.length !== 0) {
      let temp_result = res_result;
      SetApiResponce(res_result)
      temp_result.map((d, index) => {
        let value = d.Energy_Regenarated.value;
        dataCons_kWh = dataCons_kWh + d.dataCons_kWh.value;
        distanceInKM = distanceInKM + d.distanceInKM.value;
        dynamic_itemSelected = dynamic_itemSelected + d[itemSelected].value; //dynamic column

        vehicle_registration_number = d.key.vehicle_registration_number
        Depot_Name = d.key.Depot_Name
        DLR_ORG_CITY = d.key.DLR_ORG_CITY

        if (value != null) {
          if (itemSelected === "acLoadIdle") {
            if (value >= 0 && value < 20) {
              responce["<20"] = responce["<20"] + 1;
            } else if (value >= 20 && value < 40) {
              responce["40"] = responce["40"] + 1;
            } else if (value >= 40 && value < 60) {
              responce["60"] = responce["60"] + 1;
            } else if (value >= 60 && value < 80) {
              responce["80"] = responce["80"] + 1;
            } else if (value >= 80 && value < 100) {
              responce["100"] = responce["100"] + 1;
            } else if (value >= 100 && value < 120) {
              responce["120"] = responce["120"] + 1;
            } else if (value >= 120 && value < 140) {
              responce["140"] = responce["140"] + 1;
            } else if (value >= 140 && value < 160) {
              responce["160"] = responce["160"] + 1;
            } else if (value >= 160 && value < 180) {
              responce["180"] = responce["180"] + 1;
            } else if (value >= 180) {
              responce[">=180"] = responce[">=180"] + 1;
            }
          } else {
            if (value >= 0 && value < 50) {
              responce["<50"] = responce["<50"] + 1;
            } else if (value >= 50 && value < 100) {
              responce["100"] = responce["100"] + 1;
            } else if (value >= 100 && value < 150) {
              responce["150"] = responce["150"] + 1;
            } else if (value >= 150 && value < 200) {
              responce["200"] = responce["200"] + 1;
            } else if (value >= 200 && value < 250) {
              responce["250"] = responce["250"] + 1;
            } else if (value >= 250 && value < 300) {
              responce["300"] = responce["300"] + 1;
            } else if (value >= 300 && value < 350) {
              responce["350"] = responce["350"] + 1;
            } else if (value >= 350 && value < 400) {
              responce["400"] = responce["400"] + 1;
            } else if (value >= 400 && value < 450) {
              responce["450"] = responce["450"] + 1;
            } else if (value >= 450) {
              responce[">=450"] = responce[">=450"] + 1;
            }
          }
        }
      })

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys;
      if (itemSelected === "acLoadIdle") {
        loop_keys = ["<20", "40", "60", "80", "100", "120", "140", "160", "180", ">=180"]
      } else {
        loop_keys = ["<50", "100", "150", "200", "250", "300", "350", "400", "450", ">=450"]
      }
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }

      loop_keys.map(x => {
        if (countcheck)
          res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })

      let labels;
      if (itemSelected === "acLoadIdle") {
        labels = ["<20", "40", "60", "80", "100", "120", "140", "160", "180", ">=180"]
      } else {
        labels = ["<50", "100", "150", "200", "250", "300", "350", "400", "450", ">=450"]
      }
      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Energy Consumption (Wh/km)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };

      let kpi_one = dynamic_itemSelected / dataCons_kWh * 100
      setBox_one(kpi_one)
      let kpi_two = dynamic_itemSelected / distanceInKM * 1000
      setBox_two(kpi_two)

      if (gloablfilter.VIN_NUM.length === 1) {
        SetTableData([{
          "key": {
            "vehicleId": gloablfilter.VIN_NUM[0],
            "vehicle_registration_number":vehicle_registration_number,
            "Depot_Name":Depot_Name,
            "DLR_ORG_CITY":DLR_ORG_CITY,
          },
          "Energy_Regenarated": {
            "value": kpi_two
          }
        }])
      } else {
        res_result.sort((a, b) => b.Energy_Regenarated.value - a.Energy_Regenarated.value)
        SetTableData(res_result)
      }

      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Energy Consumption (Wh/km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: yAxisTitle,
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: barcolor },
    },
  };

  useEffect(() => {
    setTBText("Top")
    setHVACtext("total")
    if (gloablfilter.VIN_NUM.length === 1) {
      SetBarcolor("#3578b0")
      SetyAxisTitle("No. of Cycles")
      fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/kpi_histogram_table_vehicle", body: { filterdata: gloablfilter, itemSelected: itemSelected } }, responceData)
    } else {
      SetBarcolor("#83A4CF")
      SetyAxisTitle("No. of Vehicles")
      fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/kpi_histogram_table", body: { filterdata: gloablfilter, itemSelected: itemSelected } }, responceData)
    }
  }, [gloablfilter, itemSelected])

  const [TBText, setTBText] = useState("Top")
  const changeTB = (selectOp) => {
    setTBText(selectOp)
    const reversed = tableData.reverse();
    SetTableData(reversed)
  }
  const changeHVAC = (selectOp) => {
    setTBText("Top")
    let apiToCall = (gloablfilter.VIN_NUM.length === 1) ? "kpi_histogram_table_vehicle" : "kpi_histogram_table"
    if (selectOp === "total") {
      itemSelected = "acConsumption"
      fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/" + apiToCall, body: { filterdata: gloablfilter, itemSelected: "acConsumption" } }, responceData)
    } else if (selectOp === "idle") {
      itemSelected = "acLoadIdle"
      fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/" + apiToCall, body: { filterdata: gloablfilter, itemSelected: "acLoadIdle" } }, responceData)
    } else {
      itemSelected = "acLoadDrive"
      fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/" + apiToCall, body: { filterdata: gloablfilter, itemSelected: "acLoadDrive" } }, responceData)
    }
    setHVACtext(selectOp)
  }

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-7' : 'col-md-4')}>
        <div className="row row_margin_top">
          <div className={(loggedInUser.flagForHideShow === "ERC" ? "col-md-6 text-right pr-0" : "col-md-6 text-center pr-0" )}>
            <h3 className="mb-0 to_stick">
            {(loggedInUser.flagForHideShow === "ERC") ?
              <>
                <span className="mb-0" style={{ fontSize: "small" }}>Consumption Fraction</span>
                <span className={(loggedInUser.flagForHideShow === "ERC" ? "badge" : "badgefleet")} style={{ backgroundColor: (gloablfilter.VIN_NUM.length === 1) ? "#3578b0" : "#83A4CF" }}><span className={(loggedInUser.flagForHideShow === "ERC" ?"badge-text" :"badge-text-fleet" )}>{box_one.toFixed(2)} %</span></span>
              </>:
              <>
                <span className="mb-0" style={{ fontSize: "small" }}>Cons. Fraction</span>
                <span className={(loggedInUser.flagForHideShow === "ERC" ? "badge" : "badgefleet")} style={{ backgroundColor: (gloablfilter.VIN_NUM.length === 1) ? "#3578b0" : "#83A4CF" }}><span className={(loggedInUser.flagForHideShow === "ERC" ?"badge-text" :"badge-text-fleet" )}>{box_one.toFixed(2)} %</span></span>
              </>
            }
            </h3>
          </div>

          <div className={(loggedInUser.flagForHideShow === "ERC" ? "col-md-6 text-left" : "col-md-6 text-center" )}>
            <h3 className="mb-0 to_stick">
            {(loggedInUser.flagForHideShow === "ERC") ?
              <>
                <span className="mb-0" style={{ fontSize: "small" }}>&nbsp;Consumption Factor</span>
                <span className={(loggedInUser.flagForHideShow === "ERC" ? "badge" : "badgefleet")} style={{ backgroundColor: (gloablfilter.VIN_NUM.length === 1) ? "#3578b0" : "#83A4CF" }}><span className={(loggedInUser.flagForHideShow === "ERC" ?"badge-text" :"badge-text-fleet" )}>{box_two.toFixed(2)} Wh/km</span></span>
              </>:
              <>
                <span className="mb-0" style={{ fontSize: "small" }}>&nbsp;Cons. Factor</span>
              <span className={(loggedInUser.flagForHideShow === "ERC" ? "badge" : "badgefleet")} style={{ backgroundColor: (gloablfilter.VIN_NUM.length === 1) ? "#3578b0" : "#83A4CF" }}><span className={(loggedInUser.flagForHideShow === "ERC" ?"badge-text" :"badge-text-fleet" )}>{box_two.toFixed(2)} Wh/km</span></span>
              </>
            }
            </h3>
          </div>
        </div>
        <WaterMark />
        {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? ((HVACtext === "idle") ? (<Chart chartType="ColumnChart" data={chartdata} options={options} chartEvents={[
          {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
              const chart = chartWrapper.getChart()
              const selection = chart.getSelection()
              if (selection.length === 1) {
                const [selectedItem] = selection;
                const { row } = selectedItem;

                const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
                const count = chartWrapper.getDataTable().Wf[row].c[1].v;

                let filtered_temp = [];
                if (count !== 0) {
                  filtered_temp = apiresponce.filter(x => {
                    if (x.Energy_Regenarated.value <= barvalue && x.Energy_Regenarated.value > barvalue - 20) {
                      return x;
                    }
                    else if (x.Energy_Regenarated.value > 180 && barvalue === ">=180") {
                      return x
                    }
                    else if (x.Energy_Regenarated.value <= 20 && barvalue === "<20") {
                      return x
                    }
                  })

                  function compareObjects(object1, object2, key) {
                    let obj1 = 0
                    let obj2 = 0
                    obj1 = object1.Energy_Regenarated.value
                    obj2 = object2.Energy_Regenarated.value
                    if (obj1 > obj2) {
                      return -1
                    }
                    if (obj1 < obj2) {
                      return 1
                    }
                    return 0
                  }

                  filtered_temp.sort((value1, value2) => {
                    return compareObjects(value1, value2, 'value')
                  })
                  SetfilteredData(prestate => filtered_temp);
                  window.$('#exampleModal__' + modalName).modal('show');
                }
              }
            }
          }
        ]}
        />) : (<Chart chartType="ColumnChart" data={chartdata} options={options} chartEvents={[
          {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
              const chart = chartWrapper.getChart()
              const selection = chart.getSelection()
              if (selection.length === 1) {
                const [selectedItem] = selection;
                const { row } = selectedItem;

                const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
                const count = chartWrapper.getDataTable().Wf[row].c[1].v;

                let filtered_temp = [];
                if (count !== 0) {
                  filtered_temp = apiresponce.filter(x => {
                    if (x.Energy_Regenarated.value <= barvalue && x.Energy_Regenarated.value > barvalue - 50) {
                      return x;
                    }
                    else if (x.Energy_Regenarated.value > 450 && barvalue === ">=450") {
                      return x
                    }
                    else if (x.Energy_Regenarated.value <= 50 && barvalue === "<50") {
                      return x
                    }
                  })

                  function compareObjects(object1, object2, key) {
                    let obj1 = 0
                    let obj2 = 0
                    obj1 = object1.Energy_Regenarated.value
                    obj2 = object2.Energy_Regenarated.value
                    if (obj1 > obj2) {
                      return -1
                    }
                    if (obj1 < obj2) {
                      return 1
                    }
                    return 0
                  }

                  filtered_temp.sort((value1, value2) => {
                    return compareObjects(value1, value2, 'value')
                  })
                  SetfilteredData(prestate => filtered_temp);
                  window.$('#exampleModal__' + modalName).modal('show');
                }
              }
            }
          }
        ]}
        />)) : <NoData />)}

        <div className="modal fade" id={"exampleModal__" + modalName} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <CommanBarTable_Kratos data={filteredData} tabDataKey={"Energy_Regenarated"} />
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-5' : 'col-md-8')}>
        <div className="row mb-2">
          <div className="col-md-6 pl-2">
            <div className="dropdownSelectBtnEnergy_Kratos">
              <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeHVAC(event.target.value)} value={HVACtext}>
                <option value="total">Total</option>
                <option value="idle">Idle</option>
                <option value="drive">Drive</option>
              </select>
            </div>
          </div>
          {
            (gloablfilter.VIN_NUM.length !== 1) &&
            <div className="col-md-6 d-flex justify-content-end">
              <div className="dropdownSelectBtnEnergy_Kratos">
                <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeTB(event.target.value)} value={TBText}>
                  <option value="top">Top 10</option>
                  <option value="bottom">Bottom 10</option>
                </select>
              </div>
            </div>
          }
        </div>

        <div className="tableContent_Kratos px-2 row" style={{ overflowY: 'scroll', height: '225px' }}>
          <WaterMark />
          <table className="table table-striped">
            <thead className="histo_table_th">
              <tr>
                <th scope="col">Vin</th>
                {(loggedInUser.flagForHideShow === 'FLEETEV') &&
                <>
                <th scope="col">Reg. No.</th>
                <th scope="col">City</th>
                <th scope="col">Depo</th>
                </>
                }
                <th scope="col">CF</th>
              </tr>
            </thead>

            <tbody className="histo_table_tb">
              {(tableData.length == 0) ? <NoTableData /> : tableData.slice(0, 10).map((x, index) => {
                return (<tr key={x.key.vehicleId + "_" + index}>
                  <td scope="row">{x.key.vehicleId}</td>
                  {(loggedInUser.flagForHideShow === 'FLEETEV') &&
                  <>
                  <td>{(x.key.vehicle_registration_number)}</td>
                  <td>{(x.key.DLR_ORG_CITY)}</td>
                  <td>{(x.key.Depot_Name)}</td>
                  </>
                  }
                  <td>{(x.Energy_Regenarated.value).toFixed(2)}</td>
                </tr>)
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default HvacTotalDrive_Kratos;